import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'IPSettings',
		icon: 'acies_ip_access',
		path: 'administration/ipsettings',
		overlay: false,
		children: [],
		parents: ['Administration'],
		permission: 'iam:OrganizationsAccountsPut',
		forceTranslateKey: 'administration.sidebar.ipsettings',
	},
	{
		label: 'Drawings',
		icon: 'acies_drawing',
		path: 'administration/drawings',
		overlay: false,
		children: [],
		parents: ['Administration'],
		permission: 'drawing:StylingGetDownloadUrl',
		forceTranslateKey: 'administration.sidebar.drawings',
	},
	{
		label: 'FeatureFlags',
		icon: 'acies_feature_flags',
		path: 'administration/featureflags',
		overlay: false,
		children: [],
		parents: ['Administration'],
		permission: 'iam:FlagsVariantPut',
		forceTranslateKey: 'administration.sidebar.featureflags',
	},
	{
		label: 'SCIM Administration',
		icon: 'acies_user',
		path: 'administration/scim-administration',
		overlay: false,
		children: [],
		parents: ['Administration'],
		permission: 'iam:ScimUsersGetList',
		forceTranslateKey: 'administration.sidebar.scim-administration',
	},
	{
		label: 'Sync Monitoring',
		icon: 'acies_sync',
		path: 'administration/sync-monitoring',
		overlay: false,
		children: [],
		parents: ['Administration'],
		permission: 'one:EnvironmentGet',
		forceTranslateKey: 'administration.sync-monitoring.sidebar.title',
	},
];
